import { Platform } from "@next-platform/client-common-spicy-ui";
import { useMediaStore } from "@/hooks/useMediaStore";

const usePlatform = (): Platform => {
  const isMobile = useMediaStore((store) => store.isMobile);
  const isTablet = useMediaStore((store) => store.isTablet);
  const isDesktop = useMediaStore((store) => store.isDesktop);

  if (isMobile) {
    return Platform.MOBILE_WEB;
  }
  if (isTablet) {
    return Platform.TABLET_WEB;
  }
  if (isDesktop) {
    return Platform.DESKTOP_WEB;
  }
  // Default fallback
  return Platform.DESKTOP_WEB;
};
export default usePlatform;
